import { AnySelection, seriesSvgLine, seriesSvgMulti } from '@d3fc/d3fc-series';

import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';
import { line } from 'utils/components/TimeSeriesChart/line';
import { ObvTileDataTimeSeriesItem } from 'widgets/obvTile/obvTileData';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const obvLine = line((d: any) => d['obv'], 'data-line');

const zeroLine = seriesSvgLine()
    .crossValue(deriveTime)
    .mainValue(0)
    .decorate((s: AnySelection) => {
        s.classed(`zero-line`, true);
    });

const zeroValueLine = line<ObvTileDataTimeSeriesItem>(
    (d) => d['zero-obv'],
    'zero-value-line'
);

export const obvTilesSeries = seriesSvgMulti().series([
    obvLine,
    zeroLine,
    zeroValueLine,
]);
